<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">SESSION VOLUNTEER</h4>
                
            </div>

        </div>
        <div *ngIf="!tableshow" class="d-flex justify-content-center">
            <div class="loader"></div>
        </div>
        <div class="p-3">
            <div class="table-responsive" *ngIf="tableshow">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>Mentor</th>
                            <th>Date</th>
                            <th>Time</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let volunteer of volunteers">
                            <td style="min-width: 20px;">
                                {{volunteer.mentorFirstName}} {{volunteer.mentorLastName}}
                            </td>

                            <td style="min-width: 20px;">
                                {{volunteer.fromDate | date: 'dd-MM-yyyy'}} -
                                {{volunteer.toDate | date: 'dd-MM-yyyy'}}
                            </td>
                            <td style="min-width: 20px;">
                                {{volunteer.fromTime }} - {{volunteer.toTime }}
                            </td>
                            <!-- <td><a (click)="handleClickNavigate(volunteer.id)" class="btn btn-primary btn-sm">
                                    <i class="fas fa-eye"></i>
                                </a><td> -->
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
    </div>
</div>
